import { create } from 'zustand';

interface State {
    isVisible: boolean;
    update: (d: Partial<State>) => void;
}

export const useFaqModal = create<State>(set => ({
    isVisible: false,
    update: newState => set(state => ({ ...state, ...newState })),
}));
